// Note: These styles are deprecated, but still active in places in the app. Please use MUI typography tokens instead.

import { css } from '@emotion/react'

const up5 = css`
  font-size: 32px;
  line-height: 40px;
`

const up4 = css`
  font-size: 26px;
  line-height: 34px;
`

const up3 = css`
  font-size: 22px;
  line-height: 32px;
`

const up2 = css`
  font-size: 18px;
  line-height: 24px;
`

const up1 = css`
  font-size: 16px;
  line-height: 24px;
`

const baseline = css`
  font-size: 16px;
  line-height: 24px;
`

const down1 = css`
  font-size: 14px;
  line-height: 20px;
`

const down2 = css`
  font-size: 12px;
  line-height: 16px;
`

const semiBoldSans = css`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 600;
  font-style: normal;
`

const regularSans = css`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-style: normal;
`

const regularSansItalic = css`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;
  font-style: italic;
`

const regularSerif = css`
  font-family: 'Merriweather';
  font-weight: 400;
  font-style: normal;
  font-variant-numeric: lining-nums;
`

const up5SemiBoldSans = css`
  ${up5}
  ${semiBoldSans}
`

const up5RegularSans = css`
  ${up5}
  ${regularSans}
`

const up5RegularSansItalic = css`
  ${up5}
  ${regularSansItalic}
`

const up5RegularSerif = css`
  ${up5}
  ${regularSerif}
`

const up4SemiBoldSans = css`
  ${up4}
  ${semiBoldSans}
`

const up4RegularSans = css`
  ${up4}
  ${regularSans}
`

const up4RegularSansItalic = css`
  ${up4}
  ${regularSansItalic}
`

const up4RegularSerif = css`
  ${up4}
  ${regularSerif}
`

const up3SemiBoldSans = css`
  ${up3}
  ${semiBoldSans}
`

const up3RegularSans = css`
  ${up3}
  ${regularSans}
`

const up3RegularSansItalic = css`
  ${up3}
  ${regularSansItalic}
`

const up3RegularSerif = css`
  ${up3}
  ${regularSerif}
`

const up2SemiBoldSans = css`
  ${up2}
  ${semiBoldSans}
`

const up2RegularSans = css`
  ${up2}
  ${regularSans}
`

const up2RegularSansItalic = css`
  ${up2}
  ${regularSansItalic}
`

const up2RegularSerif = css`
  ${up2}
  ${regularSerif}
`

const up1SemiBoldSans = css`
  ${up1}
  ${semiBoldSans}
`

const up1RegularSans = css`
  ${up1}
  ${regularSans}
`

const up1RegularSansItalic = css`
  ${up1}
  ${regularSansItalic}
`

const up1RegularSerif = css`
  ${up1}
  ${regularSerif}
`

const baselineSemiBoldSans = css`
  ${baseline}
  ${semiBoldSans}
`

const baselineRegularSans = css`
  ${baseline}
  ${regularSans}
`

const baselineRegularSansItalic = css`
  ${baseline}
  ${regularSansItalic}
`

const baselineRegularSerif = css`
  ${baseline}
  ${regularSerif}
`

const down1SemiBoldSans = css`
  ${down1}
  ${semiBoldSans}
`

const down1RegularSans = css`
  ${down1}
  ${regularSans}
`

const down1RegularSansItalic = css`
  ${down1}
  ${regularSansItalic}
`

const down1RegularSerif = css`
  ${down1}
  ${regularSerif}
`

const down2SemiBoldSans = css`
  ${down2}
  ${semiBoldSans}
`

const down2RegularSans = css`
  ${down2}
  ${regularSans}
`

const down2RegularSansItalic = css`
  ${down2}
  ${regularSansItalic}
`

const down2RegularSerif = css`
  ${down2}
  ${regularSerif}
`

export const typography = {
  up5: {
    semiBoldSans: up5SemiBoldSans,
    regularSans: up5RegularSans,
    regularSansItalic: up5RegularSansItalic,
    regularSerif: up5RegularSerif,
  },
  up4: {
    semiBoldSans: up4SemiBoldSans,
    regularSans: up4RegularSans,
    regularSansItalic: up4RegularSansItalic,
    regularSerif: up4RegularSerif,
  },
  up3: {
    semiBoldSans: up3SemiBoldSans,
    regularSans: up3RegularSans,
    regularSansItalic: up3RegularSansItalic,
    regularSerif: up3RegularSerif,
  },
  up2: {
    semiBoldSans: up2SemiBoldSans,
    regularSans: up2RegularSans,
    regularSansItalic: up2RegularSansItalic,
    regularSerif: up2RegularSerif,
  },
  up1: {
    semiBoldSans: up1SemiBoldSans,
    regularSans: up1RegularSans,
    regularSansItalic: up1RegularSansItalic,
    regularSerif: up1RegularSerif,
  },
  baseline: {
    semiBoldSans: baselineSemiBoldSans,
    regularSans: baselineRegularSans,
    regularSansItalic: baselineRegularSansItalic,
    regularSerif: baselineRegularSerif,
  },
  down1: {
    semiBoldSans: down1SemiBoldSans,
    regularSans: down1RegularSans,
    regularSansItalic: down1RegularSansItalic,
    regularSerif: down1RegularSerif,
  },
  down2: {
    semiBoldSans: down2SemiBoldSans,
    regularSans: down2RegularSans,
    regularSansItalic: down2RegularSansItalic,
    regularSerif: down2RegularSerif,
  },
}
